<template>
  <div class="card card-small h-100 stats-small">

     <!-- Card Header -->
    <div class="card-header pb-0">
      <h6 class="m-0 text-center">({{ percentage }}) {{ label }}</h6>
    </div>

    <!-- Chart -->
    <div class="card-body d-flex">
      <canvas height="100" ref="drive"></canvas>
    </div>

  </div>
</template>

<script>
import Chart from '_utils/chart';
import CurrencyMask from '_common/mixins/CurrencyMask';

export default {
  name: 'd-doughnut-stats',
  mixins: [CurrencyMask],
  props: {
    /**
     * The label.
     */
    label: {
      type: String,
      default: 'Label',
    },
    /**
     * The chart dataset.
     */
    chartData: {
      type: Array,
      required: true,
      default() {
        return [];
      },
    },
    /**
     * The percentage number or string.
     */
    percentage: {
      type: [Number, String],
      default: 0,
    },
  },
  computed: {
  },
  mounted() {
    const chartOptions = {
      ...{
        maintainAspectRatio: true,
        responsive: true,
        legend: {
          display: false,
        },
        tooltips: {
          enabled: true,
          callbacks: {
            label: (tooltipItem, data) => {
              const label = data.labels[tooltipItem.index];
              const value = this.addCurrencyMask(data.datasets[0].label[tooltipItem.index]);
              return `${label}: ${value}`;
            },
          },
        },
        elements: {
          point: {
            radius: 0,
          },
          line: {
            tension: 0.33,
          },
        },
        scales: {
          xAxes: [{
            gridLines: false,
            ticks: {
              display: false,
            },
          }],
          yAxes: [{
            gridLines: false,
            scaleLabel: false,
            ticks: {
              display: false,
              isplay: false,
              // Avoid getting the graph line cut of at the top of the canvas.
              // Chart.js bug link: https://github.com/chartjs/Chart.js/issues/4790
              suggestedMax: Math.max(...this.chartData[0].data) + 1,
            },
          }],
        },
      },
    };

    const chartConfig = {
      ...{
        type: 'doughnut',
        data: {
          ...{ labels: ['Meta', 'Aprovado'] },
          ...{
            datasets: this.chartData,
          },
        },
        options: chartOptions,
      },
      ...this.chartConfig,
    };

    new Chart(this.$refs.drive, chartConfig);
  },
};
</script>

<style lang="scss" scoped>
.stats-small {
  .card-body {
    canvas {
      margin-bottom: 15px;
    }
  }
}
</style>
